<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs" >{{ $t('department.nameKh') }}</label>
        <input
          v-model="model.location_name_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('location_name_kh') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('location_name_kh')"
        >{{ errors.first('location_name_kh') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('department.nameEn') }}</label>
        <input
          v-model="model.location_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('location_name_en') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('location_name_en')"
        >{{ errors.first('location_name_en') }}</div>
      </div>
    </div>
		<div class="row">
			<div class="col-md-12">
				<ts-checkbox v-model="model.is_main_warehouse" >{{ $t('warehourse.isMain') }}</ts-checkbox>
                <div
          class="validate ts-text-xs"
          v-if="errors.has('is_main_warehouse')"
        >{{ errors.first('is_main_warehouse') }}</div>
			</div>
		</div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'warehourseForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        location_id: 0,
        location_name_kh: null,
				location_name_en: null,
				is_main_warehouse: false
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('stock/warehourse', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('stock/warehourse/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('stock/warehourse/update', {
          id: this.model.location_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.location_id = this.edit_data.location_id
        this.model.location_name_kh = this.edit_data.location_name_kh
        this.model.location_name_en = this.edit_data.location_name_en,
        this.model.is_main_warehouse = this.edit_data.is_main_warehouse
      }
    }
  }
}
</script>
